import PropTypes from 'prop-types';
import clsx from 'clsx';

const Marker = ({ show }) => {
	return (
		<>
			<div className={clsx('location-search__pin', show === true && 'is-shown')} />
		</>
	);
};

Marker.propTypes = {
	show: PropTypes.oneOfType([PropTypes.oneOf([undefined, PropTypes.bool])]),
};

export default Marker;
